import * as React from 'react'

type Route = Record<string, any>

const Context = React.createContext<Route | null | undefined>(null)
interface Props {
  baseRoute: Route
}

// TODO: Maybe abstract? This is very generic
export const RouteProvider = ({ children, baseRoute }: React.PropsWithChildren<Props>) => {
  return <Context.Provider value={baseRoute}>{children}</Context.Provider>
}

export const useRoute = (): Route => {
  const route = React.useContext(Context)

  if (!route) throw new Error('useRoute must be used within a RouteProvider')

  return route
}
